import Account from './Account';

export default Account;


// WEBPACK FOOTER //
// ./src/components/Header/components/Account/index.tsx